import WIDGETS from './widgets';

export default {
	name: 'chat_ticket_actions',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.CHAT_TICKET_ACTIONS, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
